/* <wg-sticky-atc>: mobile sticky add-to-cart bar.
   Appears once the in-page buy button leaves the viewport (IntersectionObserver, no polling).
   The Add button proxies the main product form submit so all Dawn cart behavior is preserved. */
(function () {
  if (customElements.get('wg-sticky-atc')) return;

  class WGStickyATC extends HTMLElement {
    connectedCallback() {
      this.submitId = this.getAttribute('data-submit-id');
      this.button = this.querySelector('.wg-sticky-atc__button');
      const mainSubmit = document.getElementById(this.submitId);
      if (!mainSubmit) return;

      if (this.button && mainSubmit.tagName !== 'A') {
        this.button.addEventListener('click', () => {
          const submit = document.getElementById(this.submitId);
          if (submit && !submit.disabled) submit.click();
        });
      }

      const anchor = mainSubmit.closest('.product-form__buttons') || mainSubmit;
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggleAttribute('hidden', !passed);
        },
        { threshold: 0 }
      );
      this.observer.observe(anchor);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('wg-sticky-atc', WGStickyATC);
})();
